<template>
  <Problem :son="25" :questions="questions" />
</template>

<script>
import Problem from '@/components/experimentation/problem .vue'
export default {
  components: { Problem },
  props: [],
  data() {
    return {
      questions: [
        {
          id: 0,
          question: 'lang.ct.two.four.ll_child.firstQ.question',
          options: [
            { value: 'A', label: 'lang.ct.two.four.ll_child.firstQ.options.A' },
            { value: 'B', label: 'lang.ct.two.four.ll_child.firstQ.options.B' },
            { value: 'C', label: 'lang.ct.two.four.ll_child.firstQ.options.C' },
            { value: 'D', label: 'lang.ct.two.four.ll_child.firstQ.options.D' },
          ],
          answer: '',
          result: 'D',
          score: 2,
          scored: 0,
        },
        {
          id: 1,
          question: 'lang.ct.two.four.ll_child.secondQ.question',
          options: [
            {
              value: 'A',
              label: 'lang.ct.two.four.ll_child.secondQ.options.A',
            },
            {
              value: 'B',
              label: 'lang.ct.two.four.ll_child.secondQ.options.B',
            },
            {
              value: 'C',
              label: 'lang.ct.two.four.ll_child.secondQ.options.C',
            },
            {
              value: 'D',
              label: 'lang.ct.two.four.ll_child.secondQ.options.D',
            },
          ],
          answer: '',
          result: 'C',
          score: 2,
          scored: 0,
        },
      ],
    }
  },
}
</script>